module.exports = __webpack_public_path__ + "static/img/icon_avatar.b9d0729c.png";